import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import Typography from '../../base/Typography';
import Button from '../../base/Button';
import Picture from '../../base/Picture';
import { Row, Col } from '../../base/Grid';
import './dynamic-callout.scss';

const buttonTextDefault = 'Get started';
const jsRedirect = (urlPath) => {
  window.location.replace(urlPath);
};

export const DynamicCalloutComponent = ({
  orientation, imageId, image, imageAlt, title, buttonText, url, tag,
}) => {
  // card CTA orientation
  if (orientation === 'card') {
    return (
      <div className='dynamic-callout dynamic-callout--card nmx-base'>
        <article id='' className="dynamic-callout__article">
          <a className='dynamic-callout__article-container' href={url}>
            <span className='dynamic-callout__article-tag'>
              <Typography weight={500} component='p' variant='p' color='color-primary-nm-blue'>{tag}</Typography>
            </span>
            <Picture
              variant='primary'
              src={image}
              alt={imageAlt}>
            </Picture>
            <div className="dynamic-callout__content-container">
              <Typography weight={400} component='h3' variant='h5' color='color-neutral-gray-29'>{title}</Typography>
            </div>
          </a>
        </article>
      </div>
    );
  }
  // default to Banner orientation
  useEffect(() => {
    // Grab image path from props and pass it in as a BG image for the banner orientation
    document.getElementById(imageId).style.backgroundImage = `url(${image})`;
  }, []);

  return (
    <div className='dynamic-callout dynamic-callout--banner nmx-base'>
      <Row align="center">
        <Col className='nmx-col-nested' xsmall={12} medium={3} large={3}>
          <div className='dynamic-callout__image-container' id={imageId} />
        </Col>
        <Col xsmall={12} medium={5} large={6}>
          <div className='dynamic-callout__content-container'>
            {/* TODO: Update the color value to hex once the recent typography updates come through */}
            <Typography weight={400} component='h4' variant='h5' color={'color-neutral-gray-29'}>{title}</Typography>
          </div>
        </Col>
        <Col xsmall={12} medium={4} large={3}>
          <div className='dynamic-callout__button-container'>
            <Button
              variant='tertiary'
              transparent={true}
              id='dynamic-callout-button'
              onClick={(e) => { jsRedirect(url); }}>
              {buttonText || buttonTextDefault}
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

DynamicCalloutComponent.propTypes = {
  orientation: PropTypes.string,
  imageId: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  url: PropTypes.string.isRequired,
  tag: PropTypes.string,
};

export default withTheme(DynamicCalloutComponent);
